// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N5-k","right":"styles_right__1IGE3"};